import { Button, Modal } from "flowbite-react";
import React from "react";
import { useModal } from "app/context/useModal";

export default function ContextModal() {
  const { modal, close } = useModal();
  return (
    <Modal show={modal.show} position="center" onClose={close}>
      <Modal.Header>{modal.title}</Modal.Header>
      <Modal.Body>
        <div className="space-y-6 text-gray-800 dark:text-white">
          {modal.desc}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <>
          <Button
            onClick={() => {
              modal.click();
              close();
            }}
          >
            I accept
          </Button>
          <Button color="gray" onClick={close}>
            Decline
          </Button>
        </>
      </Modal.Footer>
    </Modal>
  );
}
